import NextImage from '@/components/NextImage';

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <main className='flex min-h-screen w-full bg-typo-main'>
      <section className='relative hidden h-screen lg:fixed lg:flex lg:w-[55%] lg:flex-col'>
        <div className='flex h-full w-full'>
          <div className='relative w-full overflow-hidden bg-nlc-main'>
            <NextImage
              src='/auth-layout/card-nlc.png'
              className='absolute left-0 top-0 z-20 w-[80%]'
              alt='Card NLC'
              width={836}
              height={932}
            />
            <NextImage
              src='/auth-layout/card-nlc-trans.png'
              className='absolute left-0 top-0 z-10 w-[84%]'
              alt='Card NLC transparant'
              width={836}
              height={932}
            />
          </div>
          <div className='relative w-full overflow-hidden bg-reeva-main'>
            <NextImage
              src='/auth-layout/music-player-reeva.png'
              className='absolute right-0 top-0 z-20 w-[65%]'
              alt='Reeva'
              width={741}
              height={893}
            />
            <NextImage
              src='/auth-layout/music-player-reeva-trans.png'
              className='absolute right-0 top-0 z-10 w-[72%]'
              alt='Reeva transparant'
              width={741}
              height={893}
            />
          </div>
        </div>
        <div className='flex h-full w-full'>
          <div className='relative w-full overflow-hidden bg-npc-main'>
            <NextImage
              src='/auth-layout/jam-npc.png'
              className='absolute bottom-0 left-0 z-20 w-[55%]'
              alt='NPC'
              width={574}
              height={882}
            />
            <NextImage
              src='/auth-layout/jam-npc-trans.png'
              className='absolute bottom-0 left-0 z-10 w-[60%]'
              alt='NPC transparant'
              width={574}
              height={882}
            />
          </div>
          <div className='relative w-full overflow-hidden bg-bst-main'>
            <NextImage
              src='/auth-layout/roulute-bst-2.png'
              className='absolute bottom-0 right-0 z-20 w-[80%]'
              alt='BST'
              width={1497}
              height={1613}
            />
          </div>
        </div>

        <div className='absolute left-1/2 top-1/2 z-30 -translate-x-1/2 -translate-y-1/2'>
          <div className='relative z-30 flex w-fit items-center justify-center rounded-l-full rounded-r-full bg-typo-main py-5'>
            <NextImage
              src='/auth-layout/logo-sch.png'
              className='relative z-20 w-[50%]'
              alt='Logo SCH'
              width={492}
              height={172}
            />
          </div>
          <NextImage
            src='/auth-layout/coin-logo.png'
            className='absolute bottom-[0%] left-1/2 z-10 w-[40%] -translate-x-1/2 -translate-y-1/2'
            alt='Coin SCH'
            width={492}
            height={172}
          />
        </div>
      </section>
      <section className='absolute right-0 h-full w-full overflow-y-auto bg-typo-main lg:w-[45%]'>
        {children}
      </section>
    </main>
  );
}
